export enum SmsJourneyStep {
  SaveAsDraft = 'saveAsDraft',
  SmsSent = 'smsSent',
  TreatmentQuote = 'treatmentQuote',
  DrLetter = 'doctorLetter',
  TreatmentSelection = 'treatmentOptions',
  TreatmentPaymentFlowSelection = 'treatmentOptionsPaymentFlow',
  PracticeDocument = 'documentation',
  PlanDetails = 'planDetails',
  Compliance = 'compliance',
  IdVerification = 'idVerification',
  PaymentForDeposit = 'deposit',
  BasiqVerification = 'basiq',
  PaymentMethod = 'paymentMethod',
  PaymentSummary = 'paymentSummary'
}
